import React from 'react';
import { Calculator, BookOpen, MessageCircle, ArrowRight } from 'lucide-react';

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const items = [
  {
    icon: Calculator,
    title: 'Kalkulátorok',
    lines: [
      'Testzsír & kalória: megtudod, hol tartasz, és mennyit érdemes enned.',
      'Adonis- és Vénusz-index: megmutatja, mennyire arányos az alakod.',
      'Kaliperes mérés: megmérheted a testzsírszázalékod otthon.',
    ],
    testId: 'not-ready-card-calculator',
    onClick: () => scrollToId('calculator'),
  },
  {
    icon: BookOpen,
    title: 'Ingyenes útmutató',
    text: '5 alapelv, amivel elkerülöd a gyakori hibákat',
    testId: 'not-ready-card-guide',
    onClick: () => scrollToId('lead-magnet'),
  },
  {
    icon: MessageCircle,
    title: 'Kérdezz bátran',
    text: 'Írj, és 24 órán belül válaszolok',
    testId: 'not-ready-card-chat',
    onClick: () => window.dispatchEvent(new Event('oc:open-chat')),
  },
];

const NotReadyBar = () => {
  return (
    <section data-testid="not-ready-bar" className="bg-gray-950 border-y border-gray-800 py-10 md:py-12">
      <div className="container mx-auto px-6">
        <h2 className="text-base md:text-lg font-semibold text-gray-300 mb-5">
          Még nem állsz készen? Kezdd ezekkel:
        </h2>
      </div>

      {/* Mobilon vízszintesen húzható sor (a 3. kártya félig kilátszik),
          asztalin három egyenlő hasáb. */}
      <div className="md:container md:mx-auto md:px-6">
        <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory px-6 pb-2 md:px-0 md:pb-0 md:overflow-visible md:grid md:grid-cols-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.title}
                type="button"
                onClick={item.onClick}
                data-testid={item.testId}
                className="group snap-start shrink-0 w-[72%] sm:w-[48%] md:w-auto text-left bg-gray-900/70 border border-gray-800 hover:border-yellow-600/60 rounded-xl p-5 transition-all duration-300 hover:bg-gray-900 flex flex-col"
              >
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-yellow-600/15 text-yellow-500 mb-3 group-hover:bg-yellow-600/25 transition-colors">
                  <Icon size={20} />
                </span>
                <span className="block text-sm md:text-base font-bold text-white mb-1 break-words">
                  {item.title}
                </span>
                {item.lines ? (
                  <span className="block space-y-1.5 mt-1">
                    {item.lines.map((line) => (
                      <span key={line} className="flex gap-2 text-xs md:text-sm text-gray-400 leading-relaxed break-words">
                        <span className="text-yellow-600/70 shrink-0">·</span>
                        <span>{line}</span>
                      </span>
                    ))}
                  </span>
                ) : (
                  <span className="block text-xs md:text-sm text-gray-400 leading-relaxed break-words">
                    {item.text}
                  </span>
                )}
                <span className="inline-flex items-center gap-1 mt-auto pt-3 text-xs font-semibold text-yellow-500/90 group-hover:gap-2 transition-all">
                  Megnézem <ArrowRight size={13} />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NotReadyBar;
